/**
 * api接口的统一出口
 */
/**
 * sys 登录
 */
import sysLogin from '@/api/sys/login';
/**
 * sys 系统
 */
import sysUser from '@/api/sys/user';
import sysRole from '@/api/sys/role';
import sysPosition from '@/api/sys/position';
import sysMenu from '@/api/sys/menu';
import sysMenuRole from '@/api/sys/menuRole';
import sysTable from '@/api/sys/table';
import sysRegion from '@/api/sys/region';
import gould from '@/api/base/gould/index';
import baseFile from '@/api/base/file/file';

import banner from '@/api/config/banner';
import linkConfig from '@/api/config/linkConfig';
import choiceConfig from '@/api/config/choiceConfig';
import webConfig from '@/api/config/webConfig';
import subject from '@/api/config/subject';
import sysClass from '@/api/config/sysClass';
import school from '@/api/config/school';

import resource from '@/api/resource/resource';
import resourceSort from '@/api/resource/resourceSort';
import message from '@/api/message/message';
import inspirational from '@/api/inspirational/inspirational';

import member from '@/api/member/member';
import teacher from '@/api/teacher/teacher';
import teacherResourceSort from '@/api/teacher/teacherResourceSort';
import resourceBook from '@/api/teacher/resourceBook';
import resourceSection from '@/api/teacher/resourceSection';
import resourcePoint from '@/api/teacher/resourcePoint';
import resourceVersion from '@/api/teacher/resourceVersion';
import learnCard from '@/api/learnCard/learnCard';

import course from '@/api/course/course';
import courseVersion from '@/api/course/courseVersion';
import courseType from '@/api/course/courseType';
import courseBook from '@/api/course/courseBook';
import courseVideo from '@/api/course/courseVideo';
import courseNote from '@/api/course/courseNote';
import courseSort from '@/api/course/courseSort';
import coursePoint from '@/api/course/coursePoint';

import topic from '@/api/topic/topic';
import topicPoint from '@/api/topic/topicPoint';
import topicSection from '@/api/topic/topicSection';
import topicExam from '@/api/topic/topicExam';
import topicBook from '@/api/topic/topicBook';
import topicVersion from '@/api/topic/topicVersion';
// 导出接口
export default {
  //sys 登录
  sysLogin,
  //sys 系统
  sysUser,
  sysMenu,
  sysRole,
  sysPosition,
  sysTable,
  sysMenuRole,
  gould,
  baseFile,
  sysRegion,

  banner,
  linkConfig,
  choiceConfig,
  webConfig,
  subject,
  sysClass,
  school,
  message,

  inspirational,

  resource,
  resourceSort,

  member,
  teacher,
  teacherResourceSort,
  resourceSection,
  resourcePoint,
  resourceBook,
  resourceVersion,
  learnCard,
  course,
  courseVersion,
  courseType,
  courseBook,
  courseVideo,
  courseNote,
  courseSort,
  coursePoint,

  topic,
  topicPoint,
  topicSection,
  topicExam,
  topicBook,
  topicVersion,

}



// WEBPACK FOOTER //
// ./src/api/index.js